"use strict";
exports.__esModule = true;
exports.createChainProvider = exports.getChainProvider = void 0;
var tslib_1 = require("tslib");
var ethers_1 = require("ethers");
var constants_1 = require("../common/constants");
var config_1 = require("../common/config");
var providers_1 = require("@ethersproject/providers");
var chainProviderCache = {};
function getChainProvider(chainId, provider) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (provider)
                return [2 /*return*/, new providers_1.Web3Provider(provider)];
            return [2 /*return*/, chainProviderCache[chainId] ? chainProviderCache[chainId] : createChainProvider(chainId)];
        });
    });
}
exports.getChainProvider = getChainProvider;
function createChainProvider(chainId) {
    var chainProviderOptions = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (config_1.Config.ALCHEMY_API_KEY && { alchemy: config_1.Config.ALCHEMY_API_KEY })), (config_1.Config.ETHERSCAN_API_KEY && { etherscan: config_1.Config.ETHERSCAN_API_KEY })), (config_1.Config.INFURA_PROJECT_ID && { infura: config_1.Config.INFURA_PROJECT_ID })), (config_1.Config.POCKET_NETWORK_APPLICATION_ID && {
        pocket: config_1.Config.POCKET_NETWORK_APPLICATION_ID
    })), (config_1.Config.QUORUM && {
        quorum: config_1.Config.QUORUM
    }));
    var chainProvider;
    if (chainId === constants_1.CHAIN_IDS.BNB_MAINNET) {
        chainProvider = new ethers_1.ethers.providers.JsonRpcProvider('https://bsc-dataseed.binance.org/', 56);
    }
    else if (chainId === constants_1.CHAIN_IDS.MATIC_MAINNET) {
        chainProvider = new ethers_1.ethers.providers.JsonRpcProvider(constants_1.CHAINS[chainId].providerRPCs.ALCHEMY + config_1.Config.ALCHEMY_API_KEY, 137);
    }
    else if (chainId === constants_1.CHAIN_IDS.MATIC_MUMBAI) {
        chainProvider = new ethers_1.ethers.providers.JsonRpcProvider(constants_1.CHAINS[chainId].providerRPCs.ALCHEMY + config_1.Config.ALCHEMY_API_KEY, 80001);
    }
    else {
        chainProvider = ethers_1.ethers.getDefaultProvider(chainId, chainProviderOptions);
    }
    chainProviderCache[chainId] = chainProvider;
    return chainProvider;
}
exports.createChainProvider = createChainProvider;
